export enum AdminRole {
    Admin = 'Admin',
    Moderator = 'Moderator',
    Translator = 'Translator',
}

export interface AdminUserInfo {
    uid: string;
    name: string;
    role: AdminRole;
    scope: string;
    exp: number;
}
